import React from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'reactstrap'
import useFetchingProductMappings from './useFetchingProductMappings'
import LoadingSpinner from '../Shared/LoadingSpinner'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import HeaderRow from '../Shared/LayoutComponents/HeaderRow'
import ProductMappingItem from './ProductMappingItem'
import PageHeading from '../Shared/LayoutComponents/PageHeading'

const ProductMapping = (props) => {
  useFetchingProductMappings()

  if (props.loading) {
    return <LoadingSpinner />
  } else {
    return (
      <PageContainer>
        <Row>
          <HeaderRow>
            <PageHeading>Product Mappings</PageHeading>
          </HeaderRow>
        </Row>
        <Row>
          <Col sm={2}></Col>
          <Col sm={5}>
            <PageHeading small>ConnectWise Product</PageHeading>
          </Col>
          <Col sm={5}>
            <PageHeading small>Status</PageHeading>
          </Col>
        </Row>
        {props.productMappings && props.productMappings.length > 0 ? (
          props.productMappings.map((product, index) => {
            return <ProductMappingItem key={index} product={product} />
          })
        ) : (
          <div>No products found!</div>
        )}
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.productMapping.loading,
  productMappings: state.productMapping.productMappings,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ProductMapping)
